import { createReducer, on } from '@ngrx/store';
import * as PlaceTypeActions from './place-types.actions';
import { PlaceType } from './place-types.models';

// -----------------------------------------------------------------------------------------------------
// @ States
// -----------------------------------------------------------------------------------------------------

export interface PlaceTypesState {
    placetypes: PlaceType[];
    placetype: PlaceType | null;
    isLoading: boolean;
    error: string | null;
}

// -----------------------------------------------------------------------------------------------------
// @ Initial States
// -----------------------------------------------------------------------------------------------------

export const initialPlaceTypesState: PlaceTypesState = {
    placetypes: [],
    placetype: null,
    isLoading: false,
    error: null,
};

// -----------------------------------------------------------------------------------------------------
// @ Reducers
// -----------------------------------------------------------------------------------------------------

// PlaceTypes Reducer
export const placeTypesReducer = createReducer(
    initialPlaceTypesState,

    // On Load PlaceTypes
    on(PlaceTypeActions.loadPlaceTypes, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PlaceTypeActions.loadPlaceTypesSuccess, (state, { placetypes }) => ({
        ...state,
        isLoading: false,
        placetypes: placetypes,
    })),
    on(PlaceTypeActions.loadPlaceTypesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single PlaceType
    on(PlaceTypeActions.loadPlaceType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PlaceTypeActions.loadPlaceTypeSuccess, (state, { placetype }) => ({
        ...state,
        isLoading: false,
        placetype: placetype,
    })),
    on(PlaceTypeActions.loadPlaceTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(PlaceTypeActions.createPlaceType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PlaceTypeActions.createPlaceTypeSuccess, (state, { placetype }) => ({
        ...state,
        isLoading: false,
        placetypes: [...state.placetypes, placetype],
    })),
    on(PlaceTypeActions.createPlaceTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(PlaceTypeActions.updatePlaceType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PlaceTypeActions.updatePlaceTypeSuccess, (state, { placetype }) => ({
        ...state,
        isLoading: false,
        placetypes: state.placetypes.map((r) =>
            r.id === placetype.id ? placetype : r
        ),
    })),
    on(PlaceTypeActions.updatePlaceTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(PlaceTypeActions.deletePlaceType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PlaceTypeActions.deletePlaceTypeSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        placetypes: state.placetypes.filter((r) => r.id !== id),
    })),
    on(PlaceTypeActions.deletePlaceTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
